import { render, staticRenderFns } from "./renewalRateConfig.vue?vue&type=template&id=c6cd9236&scoped=true"
import script from "./renewalRateConfig.vue?vue&type=script&lang=js"
export * from "./renewalRateConfig.vue?vue&type=script&lang=js"
import style0 from "./renewalRateConfig.vue?vue&type=style&index=0&id=c6cd9236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cd9236",
  null
  
)

export default component.exports